import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import {
  fetchHotelSearchPrice,
  getSingleHotelData,
  getHotelSearched,
  fetchSingleHotelData,
  hotelSearchAsync,
  getLoading,
  getGuestDetails,
  fetchSingleHotelDataPrice,
  getsingleHotelPrice,
  getSinglePriceLoading,
} from "../../../../features/bookings/hotelSlice";
import Loader from "../../../../helpers/Loader";
import Title from "./title/Title";
import TabWrapper from "./TabWrapper";
import Location from "./location/Location";
import AllAminities from "./AllAminities";
import SelectRoom from "./rooms/SelectRoom";
import { useRef } from "react";
import { getLogin } from "../../../../features/userSlice";

const HotelDetails = () => {
  const dispatch = useDispatch();
  // const hotelSearched = useSelector(getHotelSearched);
  const singleData = useSelector(getSingleHotelData);
  const loading = useSelector(getLoading);
  const singleLoading = useSelector(
    (state) => state.hotel.singleLoading,
    shallowEqual
  );
  const { Authorization } =
    JSON.parse(sessionStorage.getItem("userData")) || {};
  const [uiLoader, setUiLoader] = useState(false);
  const guestDetails = useSelector(getGuestDetails);
  const userDatas = useSelector(getLogin);
  const userData = JSON.parse(sessionStorage.getItem("userData")) || {};
  const singleHotelPrice = useSelector(getsingleHotelPrice);
  const SinglePriceLoading = useSelector(getSinglePriceLoading);
  const scrollIntoView = useRef(null);

  const [searchParams] = useSearchParams();
  const [previousLogin, setPreviousLogin] = useState(
    Object.keys(userData).length
  );
  const [queryData, setQueryData] = useState(
    Object.fromEntries([...searchParams])
  );
  const [val, setVal] = useState([]);

  useEffect(() => {
    if (singleData !== "") {
      setVal(singleData);
      scrollIntoView.current?.scrollIntoView({ behavior: "smooth" });

      sessionStorage.setItem("hotelDetails", JSON.stringify(singleData));
      sessionStorage.setItem("hotelForm", JSON.stringify(queryData));
    }
  }, [singleData]);

  useEffect(() => {
    if (Object.keys(userData).length > 0) {
      if (previousLogin === 0 && userData?.role === "Agent") {
        setPreviousLogin(1);
        window.location.reload();
      }
    }
  }, [userDatas]);

  useEffect(() => {
    const sessionData = JSON.parse(sessionStorage.getItem("hotelForm"));
    const guestDetails = JSON.parse(sessionData.guestDetails);

    dispatch(
      fetchSingleHotelData({ state: sessionData, guestDetails, Authorization })
    );
    dispatch(
      fetchSingleHotelDataPrice({
        state: sessionData,
        guestDetails,
        Authorization,
      })
    );
  }, [queryData]);

  // if (loading || singleLoading) {
  //   return <Loader />;
  // }

  return (
    <>
      <section className="hotel-detail" ref={scrollIntoView}>
        <div className="container my-4">
          {loading || singleLoading ? (
            <div class="row">
              <div class="col-lg-6">
                <div class="loader-bg structure-box1"></div>
              </div>
              <div class="col-lg-3">
                <div class="loader-bg structure-box2"></div>
                <div class="loader-bg structure-box2 mt-4"></div>
              </div>
              <div class="col-lg-3">
                <div class="loader-bg structure-box3"></div>
                <div class="loader-bg structure-box4 mt-4"></div>
              </div>
            </div>
          ) : (
            <div className="row">
              <Title vals={val} />
              <TabWrapper vals={val} />
              <Location vals={val} />
              <SelectRoom
                loader={SinglePriceLoading}
                rooms={
                  singleHotelPrice?.data?.[0]?.Rooms !== undefined &&
                  singleHotelPrice?.data?.[0]?.Rooms
                }
              />

              <AllAminities vals={val} />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default HotelDetails;
